import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxCollection,
  RxDocument,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const logLiteral = {
  title: 'Log Schema',
  description: 'Describes a log, which may or may not associated with a pack message',
  version: 0,
  keyCompression: false,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    name: {
      type: 'string',
    },
    pack: {
      ref: 'packs',
      type: ['string', 'null'],
    },
    message: {
      ref: 'messages',
      type: ['string', 'null'],
    },
    resourceName: {
      type: ['string', 'null'],
    },
    createdAt: {
      type: ['string', 'null'],
    },
    updatedAt: {
      type: ['string', 'null'],
    },
  },
  required: ['id', 'name'],
  indexes: [],
} as const

const schemaTyped = toTypedRxJsonSchema(logLiteral)

export type LogDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>

export const logSchema: RxJsonSchema<LogDocType> = schemaTyped

export type LogDocMethods = {
  getFormattedCreatedAt: () => string
}

export const logDocMethods = {
  getFormattedCreatedAt() {
    return new Date(this.createdAt).toLocaleString()
  },
}

export type LogDocument = RxDocument<LogDocType, LogDocMethods>

export type LogCollectionMethods = {
  test: () => void
}

export type LogCollection = RxCollection<LogDocType, LogDocMethods, LogCollectionMethods>
